// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SearchOption-module__subTitle__3bHyF{color:gray;font-size:0.9em;display:flex}.SearchOption-module__match__2Idzv{line-height:1.5rem;white-space:normal}\n", ""]);
// Exports
exports.locals = {
	"subTitle": "SearchOption-module__subTitle__3bHyF",
	"match": "SearchOption-module__match__2Idzv"
};
module.exports = exports;
